import { plainToClass } from 'class-transformer';
import { validate, validateField, ValidationError, ValidatorOptions } from '@lgce/class-validator';

export function FormModel(superclass: any): any {
  return class extends superclass {
    public errors: any = {};
    public labels: any = {};
    public original: any;

    constructor() {
      super();
    }

    public toDto(): typeof superclass {
      return plainToClass(superclass, this, { excludeExtraneousValues: true });
    }

    public get isValid(): boolean {
      return Object.keys(this.errors).length === 0;
    }

    public isFieldValid(key: string): boolean {
      return !this.errors[key];
    }

    public fieldType(key: string): string | undefined {
      return this.isFieldValid(key) ? undefined : 'is-danger';
    }

    public async validate(validatorOptions?: ValidatorOptions): Promise<void> {
      const result = await validate(this, validatorOptions);
      this.errors = this.setError(result, validatorOptions);
    }

    public async validateField(field: string): Promise<void> {
      const fieldError = await validateField(field, this, {});
      let errMsg = '';

      if (fieldError) {
        for (const key in fieldError.constraints) {
          if (Object.prototype.hasOwnProperty.call(fieldError.constraints, key)) {
            const constraintError = fieldError.constraints[key];
            errMsg = constraintError.message;
            break;
          }
        }

        this.errors = {
          ...this.errors,
          [field]: errMsg,
        };
      } else {
        delete this.errors[field];
        this.errors = { ...this.errors };
      }
    }

    public setError(result: ValidationError[], validatorOptions?: ValidatorOptions): object {
      const propBag = {};

      for (const error of result) {
        for (const key in error.constraints) {
          if (Object.prototype.hasOwnProperty.call(error.constraints, key)) {
            const constraintError = error.constraints[key];
            const stopAtFirstError = !validatorOptions
              || validatorOptions
              && (validatorOptions.stopAtFirstError
                  || validatorOptions.stopAtFirstError === undefined
                  || validatorOptions.stopAtFirstError === null);

            if (stopAtFirstError) {
              (propBag as any)[error.property] = constraintError.message;
              break;
            } else {
              (propBag as any)[error.property] = (propBag as any)[error.property] || [];
              (propBag as any)[error.property].push(constraintError.message);
            }
          }
        }

        // Recursively set errors
        if (error.children.length >  0) {
          error.value.errors = error.value.setError(error.children, validatorOptions);
        }
      }

      return propBag;
    }
  };
}
